"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/ban-ts-comment */
const react_1 = __importDefault(require("react"));
const dayjs_1 = __importDefault(require("dayjs"));
const DateUtils_1 = require("utils/DateUtils");
const HelperUtils_1 = require("utils/HelperUtils");
const AntdCalendar_1 = __importDefault(require("components/shared/Calendar/AntdCalendar"));
const SVGIcon_1 = __importDefault(require("components/shared/SVGIcon"));
const ReviewDeadlineCalendar = ({ fullWidth, label = 'Review Deadline', onChange, value }) => {
    const setDateValueHandler = (value) => {
        const date = (0, DateUtils_1.formatTimezone)(value, 'end');
        onChange && onChange(date);
    };
    return (react_1.default.createElement("div", { className: "relative" },
        react_1.default.createElement("p", { className: "typography-h100 text-n-800 mb-[8px]" }, (0, HelperUtils_1.getObjectiveLocale)(label)),
        react_1.default.createElement(AntdCalendar_1.default, null,
            react_1.default.createElement(AntdCalendar_1.default.Trigger, null,
                react_1.default.createElement("div", { className: `border-[1px] border-solid border-n-400 rounded-[4px] py-[4px] pr-[8px] pl-[16px] flex items-center flex justify-between ${fullWidth ? 'w-[100%]' : 'w-[240px]'}` },
                    react_1.default.createElement("span", { className: "typography-paragraph mr-[16px] cursor-pointer" }, (0, HelperUtils_1.getDateLocale)((0, dayjs_1.default)(value))),
                    react_1.default.createElement(SVGIcon_1.default, { size: 24, iconName: "icon-calendar_today", fillColor: "var(--base-600)" }))),
            react_1.default.createElement(AntdCalendar_1.default.Content, { position: "left", setDateValueHandler: setDateValueHandler, isDual: true, leftSidebarContent: "no", disabledDate: (current) => current && current.add(1, 'day') < (0, dayjs_1.default)(), calendarType: "reviewDeadline" }))));
};
exports.default = ReviewDeadlineCalendar;
